<template>
	<v-list-group :color="color" :prepend-icon="prependIcon">
		<template v-slot:activator>
			<v-list-item-title>{{title}}</v-list-item-title>
		</template>
		<div v-for="(item, i) in items" :key="i">
			<bee-list-item :item="item" :context="item.context"></bee-list-item>
			<v-divider class="my-2 mx-3" v-if="item.with_divider"></v-divider>
		</div>
	</v-list-group>
</template>
<script>
export default {
	name: "bee-list-group",
	props: ["items", "color", "prependIcon", "title"]
};
</script>
